<template>
    <div class="about__section">
        <h3>{{ l('ABOUT.DEVICE_HEADING') }}</h3>
        <dl v-if="device">
            <dt>{{ l('ABOUT.DEVICE_NAME') }}</dt>
            <dd>{{ device.name }}</dd>

            <dt>{{ l('ABOUT.DEVICE_ID') }}</dt>
            <dd>{{ device.ID }}</dd>

            <dt>{{ l('ABOUT.DEVICE_GUID') }}</dt>
            <dd>{{ device.guid }}</dd>

            <dt>{{ l('ABOUT.DEVICE_GUID_ASSIGNED') }}</dt>
            <dd>{{ deviceAssignedAt }}</dd>

            <dt>{{ l('ABOUT.DEVICE_TRADING_SESSION') }}</dt>
            <dd>{{ device.currentTradingSessionID }}</dd>
        </dl>
    </div>
</template>

<script>
import { cloneDeep } from '@/functions/clone';
import { container } from '@/container';
import { dateFilter } from '@/vue/filters/dateFilter';

export default {
    name: 'AboutDeviceSection',

    data() {
        return {
            device: null,
        };
    },

    computed: {
        deviceAssignedAt() {
            return dateFilter(this.device.guidAssigned, true);
        },
    },

    created() {
        // Clone the current device in case Vue's reactivity messes up the Device object.
        this.device = cloneDeep(container.currentDevice.device);
    },
};
</script>
